var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 875,
    height: 209,
    viewBox: "0 0 875 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M892.879 235.994L892.879 93.7539C834.029 77.5364 680.353 51.1831 536.447 75.5092C356.566 105.917 294.246 143.362 135.461 142.519C-33.0114 141.624 -49.1194 33.5072 -288.377 62.4346L-303 235.994L892.879 235.994Z",
    fill: "url(#paint0_linear_852_206685)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M892.879 235.994L892.879 93.7539C834.029 77.5364 680.353 51.1831 536.447 75.5092C356.566 105.917 294.246 143.362 135.461 142.519C-33.0114 141.624 -49.1194 33.5072 -288.377 62.4346L-303 235.994L892.879 235.994Z",
    stroke: "#4B69B2",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M892.879 235.994L892.879 93.7539C834.029 77.5364 680.353 51.1831 536.447 75.5092C356.566 105.917 294.246 143.362 135.461 142.519C-33.0114 141.624 -49.1194 33.5072 -288.377 62.4346L-303 235.994L892.879 235.994Z",
    stroke: "#4B69B2",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1074 214.489L1074 72.1013C1016.03 55.867 864.635 29.4863 722.87 53.8377C545.664 84.277 484.271 121.761 327.849 120.917C161.882 120.021 -58.8114 -24.1138 -294.51 4.84361L-294.51 208.051L1074 214.489Z",
    fill: "url(#paint1_linear_852_206685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 214.489L1074 72.1013C1016.03 55.867 864.635 29.4863 722.87 53.8377C545.664 84.277 484.271 121.761 327.849 120.917C161.882 120.021 -58.8114 -24.1138 -294.51 4.84361L-294.51 208.051L1074 214.489Z",
    stroke: "#4B69B2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 214.489L1074 72.1013C1016.03 55.867 864.635 29.4863 722.87 53.8377C545.664 84.277 484.271 121.761 327.849 120.917C161.882 120.021 -58.8114 -24.1138 -294.51 4.84361L-294.51 208.051L1074 214.489Z",
    stroke: "#4B69B2",
    strokeOpacity: 0.2,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_206685",
    x1: 168.773,
    y1: 126.751,
    x2: 167.86,
    y2: 235.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#6182D5",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#395497",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_206685",
    x1: 360.664,
    y1: 105.133,
    x2: 359.736,
    y2: 213.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#6182D5",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#395497",
    stopOpacity: 0.21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalWave);
export default __webpack_public_path__ + "static/media/modal-wave.55b99c0c371ab75cac0253fb6a2a719c.svg";
export { ForwardRef as ReactComponent };